(function() {
  var Controller, string_utils,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Controller = App.loadClass('core::Angular/Controller');

  string_utils = App.load('core::utils/string');

  exports.DefineController = (function(superClass) {
    extend(DefineController, superClass);

    function DefineController(scope, transitions, state, filterService, service, window, changes) {
      this.scope = scope;
      this.transitions = transitions;
      this.state = state;
      this.filterService = filterService;
      this.service = service;
      this.window = window;
      this.changes = changes;
      this.loadData = bind(this.loadData, this);
      this.save = bind(this.save, this);
      this.cancel = bind(this.cancel, this);
      this.updateMarker = bind(this.updateMarker, this);
      this.updateBoundary = bind(this.updateBoundary, this);
      this.createMarkerFromBoundary = bind(this.createMarkerFromBoundary, this);
      this.createBoundaryEventListener = bind(this.createBoundaryEventListener, this);
      this.createMarkerEventListener = bind(this.createMarkerEventListener, this);
      this.populateMapWithFieldBoundaries = bind(this.populateMapWithFieldBoundaries, this);
      this.updateBoundaries = bind(this.updateBoundaries, this);
      this.generateMarkerIcons = bind(this.generateMarkerIcons, this);
      this.initMarkerLayer = bind(this.initMarkerLayer, this);
      this.initBoundaryLayer = bind(this.initBoundaryLayer, this);
      DefineController.__super__.constructor.call(this, this.scope, this.transitions);
      this.scope.cancel = this.cancel;
      this.scope.save = this.save;
      this.boundariesToMarkers = [];
      this.markersToBoundaries = [];
      this.availableStatus = {
        'Selected': '#3286AB',
        'Not Key': '#a9a9a9',
        'Not Started': '#00FF00',
        'Incomplete': '#5ac272',
        'Complete': '#5ac272'
      };
      this.scope.$watch((function(_this) {
        return function() {
          return _this.filterService.current_filters;
        };
      })(this), (function(_this) {
        return function(current_filters) {
          _this.filters = current_filters;
          return _this.loadData();
        };
      })(this));
      this.transitionStart = this.transitions.onStart({}, (function(_this) {
        return function($transition) {
          if (string_utils.startsWith($transition.to().name, _this.state.current.name)) {
            return;
          }
          if (_this.changes.changesMade()) {
            if (!_this.window.confirm('You have unsaved changes.\n\nAre you sure you want to leave this page?')) {
              return false;
            } else {
              return App.layer_store.empty();
            }
          } else {
            return App.layer_store.empty();
          }
        };
      })(this));
      this.window.onbeforeunload = (function(_this) {
        return function() {
          if (_this.changes.changesMade()) {
            return 'You have unsaved changes.';
          }
          return null;
        };
      })(this);
      this.scope.$on('$destroy', (function(_this) {
        return function() {
          _this.window.onbeforeunload = null;
          return _this.transitionStart();
        };
      })(this));
    }

    DefineController.prototype.initBoundaryLayer = function() {
      this.oldMaxZoom = App.map.options.maxZoom;
      App.map.options.maxZoom = 17;
      this.maxZoom = 12;
      this.boundaryLayer = new L.FeatureGroup();
      App.layer_store.store('fields_layer', this.boundaryLayer);
      return App.map.on('zoomend', this.updateBoundaries);
    };

    DefineController.prototype.initMarkerLayer = function() {
      this.markerLayer = new L.MfMarkerClusterGroup({
        zoomToBoundsOnClick: true
      });
      return App.layer_store.store('marker_cluster', this.markerLayer);
    };


    /*
    Initialize marker icons. These are the pushpins that represent
    a field on the map, and they are colorcoded by key field status.
     */

    DefineController.prototype.generateMarkerIcons = function() {
      var color, ref, results1, status;
      this.icons = {};
      ref = this.availableStatus;
      results1 = [];
      for (status in ref) {
        color = ref[status];
        results1.push(this.icons[status] = new L.mapbox.marker.icon({
          'marker-size': 'large',
          'marker-color': color,
          'marker-symbol': 'farm'
        }));
      }
      return results1;
    };

    DefineController.prototype.updateBoundaries = function() {
      if (App.map.getZoom() > this.maxZoom) {
        return App.map.addLayer(this.boundaryLayer);
      } else {
        return App.map.removeLayer(this.boundaryLayer);
      }
    };


    /*
    Add fields to map
     */

    DefineController.prototype.populateMapWithFieldBoundaries = function(results) {
      var boundary, bounds, field, fields, i, len, marker;
      fields = results.fields;
      bounds = results.bounds;
      this.changes.clear();
      for (i = 0, len = fields.length; i < len; i++) {
        field = fields[i];
        if ((field.mid_lat != null) && (field.mid_lng != null)) {
          if (field.status !== 'Not Key') {
            this.changes.keyFields.push(field.id);
            this.changes.originalKeyFields.push(field.id);
          }
          boundary = L.geoJson($.parseJSON(field.json), {
            style: (function(_this) {
              return function() {
                return {
                  weight: 2,
                  opacity: 1,
                  fillOpacity: .5,
                  color: _this.availableStatus[field.status],
                  fillColor: _this.availableStatus[field.status]
                };
              };
            })(this)
          });
          this.createBoundaryEventListener(boundary);
          boundary.field = field;
          marker = this.createMarkerFromBoundary(boundary, field.status);
          boundary.marker = marker;
          this.boundaryLayer.addLayer(boundary);
          this.markerLayer.addLayer(marker);
        }
      }
      if (fields.length > 0) {
        return App.map.fitBounds([[bounds.south, bounds.west], [bounds.north, bounds.east]], {
          padding: [30, 30]
        });
      }
    };


    /*
    Handles highlighting of boundary when clicking on marker
     */

    DefineController.prototype.createMarkerEventListener = function(marker) {
      return marker.on('click', (function(_this) {
        return function(e) {
          return _this.markerLayer.eachLayer(function(marker) {
            if (marker._leaflet_id === e.target._leaflet_id) {
              return _this.updateBoundary(marker.boundary._leaflet_id);
            }
          });
        };
      })(this));
    };


    /*
    Handles highlighting of boundary when clicking on fields
     */

    DefineController.prototype.createBoundaryEventListener = function(boundary) {
      return boundary.on('click', (function(_this) {
        return function(e) {
          var layer_id;
          layer_id = e.target._leaflet_id;
          return _this.updateBoundary(layer_id);
        };
      })(this));
    };


    /*
    Create Marker/Listener from Field and status
     */

    DefineController.prototype.createMarkerFromBoundary = function(boundary, status) {
      var marker, statusIcon;
      statusIcon = this.icons[status];
      marker = L.marker([boundary.field.mid_lat, boundary.field.mid_lng], {
        icon: statusIcon
      });
      marker.boundary = boundary;
      if (status === 'Incomplete' || status === 'Complete') {
        marker.bindPopup('This Key Field has been sampled.', {
          closeButton: false
        });
      } else if (status === 'Not Key') {
        marker.bindPopup('This is not a Key Field.', {
          closeButton: false
        });
      } else if (status === 'Not Started') {
        marker.bindPopup('This is a Key Field.', {
          closeButton: false
        });
      } else if (status === 'Selected') {
        marker.bindPopup('This will become a Key Field.', {
          closeButton: false
        });
      }
      marker.on('mouseover', function(e) {
        return this.openPopup();
      });
      marker.on('mouseout', function(e) {
        return this.closePopup();
      });
      boundary.on('mouseover', function(e) {
        return marker.openPopup();
      });
      boundary.on('mouseout', function(e) {
        return marker.closePopup();
      });
      this.createMarkerEventListener(marker);
      return marker;
    };


    /*
    Update Boundary based on the boundary id
     */

    DefineController.prototype.updateBoundary = function(layer_id) {
      return this.boundaryLayer.eachLayer((function(_this) {
        return function(boundary) {
          var index, is_same, new_status, not_key, not_started, selected;
          is_same = boundary._leaflet_id === layer_id;
          not_key = boundary.field.status === 'Not Key';
          not_started = boundary.field.status === 'Not Started';
          if (is_same && (not_started || not_key)) {
            index = _this.changes.keyFields.indexOf(boundary.field.id);
            if (index > -1) {
              new_status = 'Not Key';
              not_key = _this.availableStatus[new_status];
              boundary.setStyle({
                color: not_key,
                fillColor: not_key
              });
              _this.updateMarker(layer_id, new_status);
              return _this.changes.keyFields.splice(index, 1);
            } else {
              if (not_started) {
                new_status = 'Not Started';
              } else {
                new_status = 'Selected';
              }
              selected = _this.availableStatus[new_status];
              boundary.setStyle({
                color: selected,
                fillColor: selected
              });
              _this.updateMarker(layer_id, new_status);
              return _this.changes.keyFields.push(boundary.field.id);
            }
          }
        };
      })(this));
    };


    /*
    Update the marker for the given boundary from old status to new status
    NOTE: markers are image files so they must be replaced entirely
     */

    DefineController.prototype.updateMarker = function(boundary_id, new_status) {
      return this.markerLayer.eachLayer((function(_this) {
        return function(marker) {
          var new_marker;
          if (marker.boundary._leaflet_id === boundary_id) {
            new_marker = _this.createMarkerFromBoundary(marker.boundary, new_status);
            _this.markerLayer.removeLayer(marker);
            return _this.markerLayer.addLayer(new_marker);
          }
        };
      })(this));
    };


    /*
    Reset boundary/markers and field ids
     */

    DefineController.prototype.cancel = function() {
      var to_add, to_delete;
      to_add = this.changes.toAdd();
      to_delete = this.changes.toDelete();
      this.boundaryLayer.eachLayer((function(_this) {
        return function(boundary) {
          var status;
          if (to_add.indexOf(boundary.field.id) > -1) {
            status = _this.availableStatus[boundary.field.status];
            boundary.setStyle({
              color: status,
              fillColor: status
            });
            _this.updateMarker(boundary._leaflet_id, boundary.field.status);
          }
          if (to_delete.indexOf(boundary.field.id) > -1) {
            status = _this.availableStatus[boundary.field.status];
            boundary.setStyle({
              color: status,
              fillColor: status
            });
            return _this.updateMarker(boundary._leaflet_id, boundary.field.status);
          }
        };
      })(this));
      return this.changes.reset();
    };


    /*
    Save Key Fields for given year and reload
     */

    DefineController.prototype.save = function() {
      if (!this.changes.changesMade()) {
        this.scope.$emit('KeyFieldDefine:displayMessage', {
          type: 'info',
          msg: 'No changes to save'
        });
        return;
      }
      this.scope.$emit('KeyFieldDefine:displayMessage', {
        type: 'info',
        msg: 'Saving...'
      });
      return this.service.save(this.filters.years[0].value, this.changes.toAdd(), this.changes.toDelete()).then((function(_this) {
        return function(response) {
          var jsr;
          jsr = response.data;
          _this.scope.$emit('KeyFieldDefine:displayMessage', jsr.status);
          if (jsr.status.type === 'success') {
            _this.changes.update();
            return _this.loadData();
          }
        };
      })(this));
    };

    DefineController.prototype.loadData = function() {
      App.layer_store.empty();
      this.generateMarkerIcons();
      this.initBoundaryLayer();
      this.initMarkerLayer();
      return this.service.fetchFields(this.filters).then((function(_this) {
        return function(response) {
          var jsr;
          jsr = response.data;
          return _this.populateMapWithFieldBoundaries(jsr.data.results);
        };
      })(this));
    };

    return DefineController;

  })(Controller);

}).call(this);
